module.exports = {"540524100":"琼结镇","540524200":"加麻乡","540524201":"下水乡","540524202":"拉玉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540524.json
// module id = 2863
// module chunks = 0